import EditorAbstractField from "./EditorAbstractField.mjs";

const EditorLabelOnlyField = class extends EditorAbstractField {
	field() {
		return this.textareaField();
	}
}

export default EditorLabelOnlyField;
